module.exports = __webpack_public_path__ + "img/game_night_graphic.a389074d.png";